import { useEffect, useRef } from "react";
import "./ScrollProgress.css";

function ScrollProgress() {
	// Write scaleX straight to the DOM via a ref so scrolling never triggers
	// a React re-render (one style mutation per rAF instead of a reconcile).
	const barRef = useRef(null);

	useEffect(() => {
		let raf = 0;
		const update = () => {
			if (raf) return;
			raf = requestAnimationFrame(() => {
				const el = document.documentElement;
				const max = el.scrollHeight - el.clientHeight;
				const ratio = max > 0 ? el.scrollTop / max : 0;
				if (barRef.current) {
					barRef.current.style.transform = `scaleX(${ratio})`;
				}
				raf = 0;
			});
		};
		window.addEventListener("scroll", update, { passive: true });
		window.addEventListener("resize", update, { passive: true });
		update();
		return () => {
			window.removeEventListener("scroll", update);
			window.removeEventListener("resize", update);
			if (raf) cancelAnimationFrame(raf);
		};
	}, []);

	return (
		<div className="scroll-progress" aria-hidden="true">
			<div className="scroll-progress-bar" ref={barRef} />
		</div>
	);
}

export default ScrollProgress;
